import { useTranslation } from "react-i18next"
import { useNavigate, useParams } from "react-router-dom"

import { BreadcrumbNav } from "@/components/breadcrumb-nav"
import { LoadingState } from "@/components/loading-state"
import { PageHeader } from "@/components/page-header"
import { useContract } from "@/features/contracts/hooks/use-contracts"
import { OrderForm } from "@/features/orders/components/order-form"
import { useCreateOrder } from "@/features/orders/hooks/use-order-mutations"
import { paths } from "@/routes/paths"

export function OrderNewPage() {
  const { contractId = "" } = useParams<{ contractId: string }>()
  const { t } = useTranslation(["orders", "contracts"])
  const navigate = useNavigate()

  const { data: contract, isLoading } = useContract(contractId)
  const create = useCreateOrder(contractId)

  if (isLoading || !contract) {
    return <LoadingState />
  }

  return (
    <div className="flex flex-col gap-6">
      <BreadcrumbNav
        crumbs={[
          { label: t("title", { ns: "contracts" }), to: paths.contracts },
          {
            label: contract.contractNumber ?? `#${contract.id}`,
            to: paths.contractDetail(contract.id),
          },
          { label: t("newOrder") },
        ]}
      />
      <PageHeader title={t("newOrder")} />
      <OrderForm
        contract={contract}
        isSubmitting={create.isPending}
        onSubmit={(payload) => {
          create.mutate(payload, {
            onSuccess: ({ id }) => {
              navigate(paths.orderDetail(id), { replace: true })
            },
          })
        }}
      />
    </div>
  )
}
